import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import { connect } from "react-redux";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import AddApproverType from "./add-approver-type";
import ACTIONS from "../../../../common/action_constant";
import { withRouter } from "react-router";
import MASTER_TYPE_CONFIG from "../../../../common/masterTypeConfig";

class ApproverTypeMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      isOpen: false,
      editData: null,
      approverTypes: [],
    };
  }

  componentDidMount() {
    this.getApproverTypes();
  }

  getApproverTypes = () => {
    const { search, offset, limit } = this.state;
    let param = `?limit=${limit}&offset=${offset}`;
    if (search) param += `&search=${encodeURIComponent(search)}`;

    this.props.dispatch({
      type: ACTIONS.CONTRACTS.GET_APPROVER_TYPES,
      param,
      onSuccess: (res) => {
        this.setState({ approverTypes: res || [] });
      },
    });
  };

  toggleAdd = () => {
    this.setState({ isOpen: !this.state.isOpen, editData: null });
  };

  editApproverType = (item) => {
    this.setState({ isOpen: true, editData: item });
  };

  deleteApproverType = (item) => {
    this.props.dispatch({
      type: ACTIONS.PLANTS.DELETE_APPROVER_TYPE_MASTER,
      data: {
        id: item.id ?? item.approval_type,
        name: item.name,
        company_id: this.props.companyId,
      },
      onSuccess: this.getApproverTypes,
    });
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getApproverTypes
    );
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getApproverTypes
      );
    }
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId } = this.props;
    const masterType = MASTER_TYPE_CONFIG.APPROVER_TYPE_MASTER;
    const navUrl = `/auditScreen/${companyId}/${masterType}`;
    history.push(navUrl);
  };

  render() {
    const { approverTypes, search } = this.state;

    return (
      <div className="location-network">
        <div style={{ paddingBottom: "15px" }}>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <Search
              id="search"
              value={search}
              placeholder="Search..."
              changeHandler={(value) => {
                this.setState(
                  { search: value, offset: 0 },
                  this.getApproverTypes
                );
              }}
              canClear={search !== ""}
              handleClearFilter={() =>
                this.setState(
                  { search: "", offset: 0 },
                  this.getApproverTypes
                )
              }
            />
            <Button value="+ Add Approver Type" click={this.toggleAdd} />
            <Button value="Audit" click={this.handleOnClickForAuditBtn} />
          </div>
        </div>

        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {approverTypes.length > 0 ? (
              approverTypes.map((item, index) => (
                <tr key={item.id ?? item.approval_type ?? index}>
                  <td>{item.name}</td>
                  <td>
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Edit})` }}
                      onClick={() => this.editApproverType(item)}
                    />
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Delete})` }}
                      onClick={() => this.deleteApproverType(item)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>

        {this.state.isOpen && (
          <AddApproverType
            toggleAdd={this.toggleAdd}
            editData={this.state.editData}
            dispatch={this.props.dispatch}
            companyId={this.props.companyId}
            refreshData={this.getApproverTypes}
          />
        )}
      </div>
    );
  }
}

export default connect()(withRouter(ApproverTypeMaster));
